export const dynamicYieldEvent = {
  methods: {
    // Dynamic Yield event for a product being added to cart
    dynamicYieldaddToCartEvent(variant) {
      try {
        let DYCartObject = [];
        axios.get('/cart.js').then((response) => {
          response.data.items.forEach((i) => {
            let obj = {
              productId: i.sku,
              quantity: i.quantity,
              itemPrice: i.price / 100, //divide here because this comes from liquid
              size:
                i.variant_options.length > 1 ? i.variant_options[1] : 'none', // can be any value
            };
            DYCartObject.push(obj);
          });

          //check if the SKU is already in the cart
          let cartPosition = -1;

          for (let i = 0; i < DYCartObject.length; i++) {
            if (DYCartObject[i].productId === variant.sku) {
              cartPosition = i;
              break;
            }
          }
          if (cartPosition > -1) {
            DYCartObject[cartPosition].quantity += 1;
          } else {
            let obj = {
              productId: variant.sku,
              quantity: 1,
              itemPrice: variant.price,
              size: variant.size ? variant.size : 'none', //can be any value
            };
            DYCartObject.push(obj);
          }
          DY.API('event', {
            name: 'Add to Cart', // Human-readable name, not used to identify an event type
            properties: {
              dyType: 'add-to-cart-v1', // Identifies this event as Add to Cart. Do Not Change
              value: variant.price, // The actual payment value. Must be positive
              productId: variant.sku, // SKU exactly as in the product feed and context.
              quantity: 1, // we always add 1
              cart: DYCartObject,
            },
          });
        });
      } catch (error) {
        //console.log(error);
        return -1;
      }
    },

    updatePageContext(variant) {
      DY.recommendationContext = { type: 'PRODUCT', data: [variant.sku] };
    },
  },
};
